<template>
  <div v-show="!OnLogin" class="breathe tabs is-toggle is-fullwidth nav-stacked" id="navbar">
    <ul style="margin-bottom: 15px">
      <li v-bind:class="{ 'is-active-big': bigtab == 0 }">
        <a
          @click="
            bigtab = 0;
            $router.push('/index');
          "
          style="font-size: 1.5em"
          >Cape Town Convention Compliance Index</a
        >
      </li>
      <li v-bind:class="{ 'is-active-big': bigtab == 1 }">
        <a
          @click="
            bigtab = 1;
            $router.push('/enforceabilityIndex');
          "
          style="font-size: 1.5em"
          >Enforceability Index (non-CTC countries)</a
        >
      </li>
    </ul>

    <ul v-if="bigtab == 0">
      <li
        v-bind:class="{ 'is-active': HasPath('/index'), 'is-disabled': !Allowed(0) }"
        v-show="!NotAgreed"
      >
        <a @click="$router.push('/index')">Compliance Index</a>
      </li>
      <li
        v-if="($store.getters['isCountryRespondent'] || $store.getters['isAdmin']) && !NotAgreed"
        v-bind:class="{
          'is-active': HasPath('/manage/questionnaires') || HasPath('/questionnaire'),
          'is-disabled': !Allowed(0),
        }"
      >
        <a @click="$router.push('/manage/questionnaires')">Questionnaires</a>
      </li>
      <li v-bind:class="{ 'is-active': HasPath('/acid-documents') }">
        <a @click="$router.push('/acid-documents')"
          >Insolvency materials</a>
      </li>
      <li
        style="position: relative"
        v-bind:class="{ 'is-active': HasPath('/historicalData'), 'is-disabled': !Allowed(0) }"
        class="dropdown-group"
      >
        <a @click="$router.push('/historicalData')">
          Graph historical data&nbsp;&nbsp;
          <i class="fas fa-chevron-down"></i>
        </a>
        <div class="menu dropdown">
          <a class="dropdown-item" @click="$router.push('/historicalData')">
            Graph historical data
          </a>
          <a
            class="dropdown-item"
            @click="($event) => $router.push({ name: 'complianceIndexMap' })"
          >
            Compliance map
          </a>
        </div>
      </li>
      <li
        style="position: relative"
        v-bind:class="{ 'is-active': HasPath('/about'), 'is-disabled': !Allowed(0, 1) }"
        class="dropdown-group"
      >
        <a @click="bigtab == 0 ? $router.push('/about') : $router.push('/enforceabilityIndex')">
          About the Index&nbsp;&nbsp;
          <i class="fas fa-chevron-down"></i>
        </a>
        <div class="menu dropdown">
          <a
            class="dropdown-item"
            @click="$router.push('/about')"
            :class="{ 'is-disabled': !Allowed(0) }"
            >About the Index</a
          >
          <a
            class="dropdown-item"
            @click="$router.push('/about/methodology')"
            :class="{ 'is-disabled': !Allowed(0) }"
            >Methodology</a
          >
          <a
            :class="{ 'is-disabled': !Allowed(0) }"
            class="dropdown-item"
            target="_blank"
            href="/Note on interpretation of watchlist notices.pdf"
          >
            Watchlist notices note
          </a>
          <a
            class="dropdown-item"
            @click="$router.push('/about/faq')"
            :class="{ 'is-disabled': !Allowed(0) }"
            >FAQ</a
          >
          <a
            class="dropdown-item"
            @click="$router.push('/about/terms')"
            :class="{ 'is-disabled': !Allowed(0) }"
            >Terms and Conditions</a
          >
          <a
            class="dropdown-item"
            @click="$router.push('/about/privacy-policy')"
            :class="{ 'is-disabled': !Allowed(0) }"
            >Privacy Policy</a
          >
          <a
            class="dropdown-item"
            @click="$router.push('/contact/comments')"
            :class="{ 'is-disabled': !Allowed(0) }"
            >Comments</a
          >
          <a
            class="dropdown-item"
            @click="$router.push('/contact/general')"
            :class="{ 'is-disabled': !Allowed(0) }"
            >General Inquiry</a
          >
          <a
            class="dropdown-item"
            @click="$router.push('/contact/technical')"
            :class="{ 'is-disabled': !Allowed(0) }"
            >Technical Inquiry</a
          >
          <a
            class="dropdown-item"
            @click="$router.push('/contact/compliance')"
            :class="{ 'is-disabled': !Allowed(0) }"
            v-show="!NotAgreed"
            >Report Compliance Activity</a
          >
        </div>
      </li>
      <li :class="{ 'is-active': HasPath('/awg-asu-assessment'), 'is-disabled': !Allowed(0) }">
        <a @click="$router.push({ name: 'asu' })">AWG's ASU Assessment</a>
      </li>
    </ul>
    <ul v-else-if="bigtab == 1">
      <li v-bind:class="{ 'is-active': HasPath('/enforceabilityIndex') }" v-show="!NotAgreed">
        <a @click="$router.push('/enforceabilityIndex')">Enforceability Index</a>
      </li>
      <li
        v-if="false && ($store.getters['isCountryRespondent'] || $store.getters['isAdmin']) && !NotAgreed"
        v-bind:class="{
          'is-active': HasPath('/manage/questionnaires') || HasPath('/questionnaire'),
        }"
      >
        <a @click="$router.push('/manage/questionnaires')">Questionnaires</a>
      </li>
      <li v-bind:class="{ 'is-active': HasPath('/acid-documents') }">
        <a @click="$router.push('/acid-documents')"
          >Insolvency materials</a>
      </li>

      <li
        style="position: relative"
        v-bind:class="{
          'is-active': HasPath('/enforceabilityIndex/historical'),
          'is-disabled': !Allowed(0, 1),
        }"
        class="dropdown-group"
      >
        <a @click="$router.push('/enforceabilityIndex/historical')">
          Graph historical data&nbsp;&nbsp;
          <i class="fas fa-chevron-down"></i>
        </a>
        <div class="menu dropdown">
          <a class="dropdown-item" @click="$router.push('/enforceabilityIndex/historical')">
            Graph historical data
          </a>
        </div>
      </li>
      <li
        style="position: relative"
        v-bind:class="{
          'is-active':
            HasPath('/enforceabilityIndex/about') || HasPath('/enforceabilityIndex/methodology'),
          'is-disabled': !Allowed(0, 1),
        }"
        class="dropdown-group"
      >
        <a @click="$router.push('/enforceabilityIndex/about')">
          About the Index&nbsp;&nbsp;
          <i class="fas fa-chevron-down"></i>
        </a>
        <div class="menu dropdown">
          <a
            class="dropdown-item"
            @click="$router.push('/enforceabilityIndex/about')"
            :class="{ 'is-disabled': !Allowed(1) }"
            >About the Index</a
          >
          <a
            class="dropdown-item"
            @click="$router.push('/about/terms')"
            :class="{ 'is-disabled': !Allowed(1) }"
            >Terms and Conditions</a
          >
          <a
            class="dropdown-item"
            @click="$router.push('/about/privacy-policy')"
            :class="{ 'is-disabled': !Allowed(1) }"
            >Privacy Policy</a
          >
          <a class="dropdown-item" @click="$router.push('/contact/general')">General Inquiry</a>
          <a class="dropdown-item" @click="$router.push('/contact/technical')">Technical Inquiry</a>
          <a
            class="dropdown-item"
            @click="$router.push('/enforceabilityIndex/methodology')"
            :class="{ 'is-disabled': !Allowed(1) }"
            >Methodology</a
          >
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import Role from "@/roles";
export default {
  data: function () {
    return {
      bigtab: 0,
    };
  },
  props: {
    hide: Boolean,
  },
  computed: {
    ScoringAccess() {
      var user = this.$store.getters.user;
      if (user)
        return user.Roles.some(
          (r) =>
            r == Role.Admin || r == Role.Enhanced || r == Role.AWGMember || r == Role.ScoringAccess
        );
      else return false;
    },
    OnLogin() {
      if (
        this.$route.path == "/login" ||
        this.$route.path == "/" ||
        this.$route.path == "/forgotPassword" ||
        this.$route.path.indexOf("/confirmEmail") >= 0
      )
        return true;
      else return false;
    },
    NotAgreed() {
      if (this.$store.getters.user && this.$store.getters.user.MustAgreeCTC) return true;
      else return false;
    },
  },
  methods: {
    HasPath(path) {
      if (this.$route.path.indexOf(path) > -1) return true;
      else return false;
    },
    Allowed(...tabstates) {
      return tabstates.some((t) => t == this.bigtab);
    },
  },
  created() {},
  mounted() {
    //const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll(".navbar-burger"), 0);
    //if ($navbarBurgers.length > 0) {
    //  $navbarBurgers.forEach(el => {
    //    el.addEventListener('click', () => {
    //      const target = el.dataset.target;
    //      const $target = document.getElementById(target);
    //      el.classList.toggle('is-active');
    //      $target.classList.toggle('is-active');
    //      if ($target.classList.contains("is-active")) {
    //        $target.style.display = "block";
    //      }
    //      else if (!$target.classList.contains("is-active")) {
    //        $target.style.display = "none";
    //      }
    //    });
    //  });
    //}
  },
};
</script>
<style>
.tabs.is-toggle li.is-active-big > a {
  color: #222223;
  background: transparent;
  box-sizing: content-box;
  border-bottom: inset 4px #fcc209;
}

#navbar a:hover {
  color: black !important;
}

#navigationHeader_navBar a {
  text-decoration-line: none;
  font-weight: 400;
}

#navbar .dropdown-item:hover {
  background-color: whitesmoke !important;
}

div.menu {
  display: none;
  position: absolute;
  background: #fff;
}

div.menu:hover,
a:hover + div.menu {
  display: block;
  z-index: 999;
}

.nav-stacked {
  flex-flow: column;
}
</style>
